import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const newSequenceFormValidation = getFormValidator(
  object().shape({
    name: string().required(),
  }),
);
